<div class="item-container">
  <div class="item-header">
    <h5 class="text-center">Job Insight</h5>
    <div class="edit-icons" mat-dialog-close>
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content ">
    <div class="header d-flex flex-wrap gap-2">
      <div class="d-flex me-auto flex-wrap me-2 gap-2">
        <div class="d-flex align-items-center">View by</div>
        <mat-select [value]="'users'" class="form-control s-1 cal-view me-3"
          (selectionChange)="onSelectionChange($event)" [(value)]="insightType">
          <mat-option value="users">Users</mat-option>
          <mat-option value="sub_category">Sub Category</mat-option>
        </mat-select>
        <div class="d-flex align-items-center">Date range:</div>
        <mat-form-field class="c-d-r" appearance="fill">
          <mat-date-range-input [rangePicker]="picker" [formGroup]="dateForm">
            <input matStartDate placeholder="Start date" (click)="picker.open()" formControlName="start" />
            <input matEndDate placeholder="End date" (click)="picker.open()" formControlName="end" />
          </mat-date-range-input>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div class="d-flex flex-wrap gap-2">
        <div class="search-cont ">
          <div class="s-in form-input" style="position:relative">
            <mat-icon class="input-icon">search</mat-icon>
            <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
              (input)="onSearch($event)" (keyup.enter)="onGo()" />
          </div>
        </div>
        <div class="search-cont">
          <div class="s-item d-box " (click)="onFilterView()">
            <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
          </div>
        </div>
        <button (click)="onExportCSV()"
          class="btn c-btn btn-outline-grey outline-btn no-sh-btn d-flex align-items-center justify-content-center"
          type="submit"> <img src="assets/images/icons/export_csv.svg" class="img-fluid me-1">Export </button>
      </div>
    </div>
    <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
    <div class="new-table mt-4">
      <div class="theader d-flex border-bottom">
        <div class="table-h name" *ngIf="insightType=='users'">Name</div>
        <div class="table-h table-b" *ngIf="insightType=='users'">Sub category</div>
        <div class="table-h table-b" *ngIf="insightType=='sub_category'">Sub category</div>
        <div class="table-h table-b" *ngIf="insightType=='sub_category'">Users</div>
        <div class="table-h table-b">Shifts on job</div>
        <div class="table-h table-b">Total Hours</div>
        <div class="table-h table-b" *ngIf="insightType!='sub_category'">Total Working Hours</div>
        <div class="table-h table-b" *ngIf="insightType!='sub_category'"></div>
        <div class="table-h table-b" *ngIf="insightType=='sub_category'"></div>
      </div>
      <div>
        <div class="d-flex" *ngFor="let element of insightArr;let i=index">
          <div class="d-flex border-bottom table-row" *ngIf="insightType=='users'">
            <div class="user-profile name table-row-e">
              <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"> </div>
              <div class="">
                <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                <div class="sub-head">{{element.email}}</div>
              </div>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <div *ngFor="let item of element.arr" class="d-flex mb-3 table-col">
                <div class="table-b table-row-e">
                  <span class="sub-c">{{item.j_sc}}</span>
                </div>
                <div class="table-b table-row-e">{{item.tot_shift}}</div>
                <div class="table-b table-row-e">{{item.tot_hour}}</div>
                <div class="table-b table-row-e">{{item.tot_w_hour}}</div>

                <div class="text-primary-c table-b table-row-e" (click)="onViewJobUsage(item,element)"> View Job Usage
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex border-bottom table-row w-100  " *ngIf="insightType=='sub_category'">
            <div class="table-b table-row-e">
              <span class="sub-c">{{element.j_sc}}</span>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex mb-3 table-col">
                <div class="d-flex align-items-center flex-grow-1 table-b table-row-e">
                  <div> {{element.tot_emp}}</div>
                </div>
                <div class="table-b table-row-e">{{element.tot_shift}}</div>
                <div class="table-b table-row-e">{{element.tot_hour}}</div>
                <div class="table-b ps-3 d-flex align-items-center ">
                  <img class="cursor-pointer" (click)="onOpenDetails(element)" src="assets/images/icons/view_icon.svg"
                    alt="">
                  <!-- <i class="material-icons cursor-pointer" (click)="onOpenDetails(element)">arrow_forward</i> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mat-table__message position-relative" *ngIf="isSpinnerLoading">
      <div class="custom-loader"> </div>
    </div>
    <div class="mat-table__message" *ngIf="insightArr.length==0 && !isSpinnerLoading">
      <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
    </div>
    <div class="pagination-cont" *ngIf="insightArr.length!=0">
      <div class="show-item">
        {{ "COMMON.SIP" | translate }}
        <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event, 'user')"
          [(ngModel)]="objData.user.itemsPerPage">
          <option [value]="item" *ngFor="let item of pageSizeOptions">
            {{ item }}
          </option>
        </select>
      </div>
      <div class="page-c">
        <ngb-pagination [collectionSize]="objData.user.count" [(page)]="objData.user.currentPage"
          [pageSize]="objData.user.itemsPerPage" [maxSize]="objData.user.maxPaginationSize"
          (pageChange)="onPageChange($event, 'user')"></ngb-pagination>
      </div>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>